export default __webpack_public_path__ + "static/media/skyship18.cf5649da.webp";